import { JSX } from 'react';
import { C01AccordionItemProps } from './C01AccordionItem.types';
import { AccordionContent, AccordionItem, AccordionTrigger } from '@ahc-digital/component-library';
import { useConditionalRendering } from 'src/shared/useConditionalRendering';
import { translationClasses } from 'src/shared/TranslationClasses';
import { useCreateMarketingRenderingHame } from 'src/shared/useCreateMarketingRenderingName';
import { checkDatasourceForRendering } from '@/shared/checkDatasourceForRendering';

const Default = (props?: C01AccordionItemProps): JSX.Element => {
  const { renderText, renderRichText } = useConditionalRendering();
  const { rendering, params, fields } = props || {};
  const marketingRenderingName = useCreateMarketingRenderingHame(
    rendering?.componentName as string
  );

  return (
    <AccordionItem
      className={translationClasses(params)}
      id={params?.AnchorLinkTargetName}
      value={rendering?.uid || ''}
      data-component={marketingRenderingName}
    >
      <AccordionTrigger>{renderText(fields?.Headline)}</AccordionTrigger>
      <AccordionContent>{renderRichText(fields?.SupportCopy)}</AccordionContent>
    </AccordionItem>
  );
};

export default checkDatasourceForRendering<C01AccordionItemProps>(Default);
